import React, { useState, useEffect } from "react";
import { Pie } from "@ant-design/plots";

const DoughNutChart = ({ data, color, type }) => {
  const [chartColor, setChartColor] = useState([]);
  const [total, setTotal] = useState(0);

  useEffect(() => {
    loadData();
  }, []);

  const loadData = () => {
    const total = data.reduce((sum, item) => sum + item.value, 0);

    setTotal(total)
    if (color == "ageDougnut") {
      setChartColor([
        "#2193AE", "#32669E", "#4945A8", "#724DAD",
        "#f36523",
        "#9d405f",
        "#487386",
        "#2b8a84",
        "#8db05c",
      ]);
    }
    else if (color == "scienceShops") {
      setChartColor(["#302E6D", "#724DAD", "#593055", "#e4857e", "#67e67d", "#ff74c2", "#7ca6b4", "#4e4e4e"])
    }
    else if (color == "disabilityDoughnut") {
      setChartColor(["#2FB8B8", "#2193AE", "#32669E", "#4945A8", "#724DAD", "#67e67d", "#ff74c2", "#7ca6b4", "#4e4e4e"])
    }
    else if (color == "demographicPie") {
      setChartColor(["#3f81af", "#37948e", "#95ba60", "#f9c232", "#f36523", "#9d405f", "#487386", "#2b8a84", "#8db05c"])
    }
    else if (color == "raceDoughnut") {
      setChartColor([ "#302E6D", "#4945A8", "#724DAD", "#2FB8B8", "#2193AE", "#32669E", '#487386', '#2b8a84',  "#487386", "#2b8a84"])
    }
    else if (color == "qualificationDoughnut") {
      setChartColor(['#8db05c', "#487386",   '#f7941d', '#f36523', '#9d405f', '#487386', '#2b8a84', "#2b8a84"]);
    }
    else {
      setChartColor(["#724dad", "#4945a8", "#32669e", "#2193ae", "#16ada0"]);
      //setChartColor(['#f9c232','#f7941d','#f36523','#9d405f','#487386','#2b8a84','#8db05c' ]);
    }
  };

  const config = {
    data,
    angleField: "value",
    colorField: "type",
    scale: {
      color: {
        range: chartColor
      },
    },
    radius: 1,
    innerRadius: 0.6,
    label: {
      text: ({ percent }) => {
        return `${percent > 0 ? percent.toFixed(2):0}%`;
      },
      // transform: [{ type: 'contrastReverse' }],
      style: {
        fontWeight: 'bold',
      },
    },
    legend: {
      color: {
        title: false,
        position: 'bottom',
        rowPadding: 5,
      },
    },
    annotations: [
      {
        type: 'text',
        style: {
          text: `${total}`,
           //text: `${data.reduce((sum, item) => sum + item.value, 0)}`,
           x: '50%',
           y: '50%',
          textAlign: 'center',
          fontSize: 40,
          fontStyle: 'bold',  
          pointerEvents: 'none'  
        },
      },
    ],
     tooltip: {
       items: [
        {
          channel: "color",
          name:type,
          valueFormatter: (val) => `${val}`,
        },
        {
          channel: "y0",
          name:'Number:',
          valueFormatter: (val) => `${val}`,
        },
        ],
      },
  };

  return (
    <>
      <Pie {...config} />
    </>
  );
};

export default DoughNutChart;
